import ChannelSettingsTab from "./ChannelSettingsTab";
export default ChannelSettingsTab;
